import { IBaseSettings } from '$/types'

export const getSettingsByGroupName = (
  baseSettings: IBaseSettings[] | undefined,
  groupName: string
) => baseSettings?.find((setting) => setting.groupName === groupName)

export const getDetailsValueByKey = (
  baseSettings: IBaseSettings[] | undefined,
  groupName: string,
  keyToSearch: string
): string => {
  const setting = getSettingsByGroupName(baseSettings, groupName)
  let details = ''

  if (setting) {
    details =
      (setting.details.find((detail) => detail.key === keyToSearch)
        ?.value as string) ?? ''
  }

  return details
}
